<template>
    <button v-show="isTouch"
            class="gh-sidebar__trigger" ref="triggerButton"
            @click="toggleSidebarOnMobile">
        Menu
        <!--<i class="el-icon-menu"></i>-->
    </button>
</template>

<script>
    export default {
        data() {
            return {
                pinScene: {}
            }
        },

        computed: {
            isTouch() {
                return this.$store.state.ui.isTouch;
            }
        },

        methods: {
            toggleSidebarOnMobile() {
                this.$emit('toggle');
            },
        },

        mounted() {
            this.pinScene = new ScrollMagic.Scene({
                offset: 10
            })
                .setClassToggle(this.$refs.triggerButton, 'is-active')
                .addTo(this.$root.scrollMagicController);
        }
    }
</script>